import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "NewRequirement2"
});
const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.75984 2.34375C4.4837 2.34375 4.25984 2.56761 4.25984 2.84375V10.4772H1.68337V13.7015C1.68337 13.9776 1.90723 14.2015 2.18337 14.2015H14.8208C15.097 14.2015 15.3208 13.9776 15.3208 13.7015V10.4772H12.7444L15.3172 10.4771L14.2123 4.8225C14.1939 4.72861 14.1117 4.66085 14.016 4.66085H12.7444V2.84375C12.7444 2.56761 12.5205 2.34375 12.2444 2.34375H4.75984ZM11.3593 3.92883C11.3593 3.81837 11.2698 3.72883 11.1593 3.72883H5.84492C5.73446 3.72883 5.64492 3.81837 5.64492 3.92883V9.46402C5.64454 9.47631 5.91818 9.47432 6.14755 9.47049C6.31628 9.46768 6.45321 9.60396 6.47803 9.77088C6.62581 10.7647 7.47682 11.572 8.50205 11.572C9.52962 11.572 10.3857 10.7772 10.5312 9.78319C10.5552 9.61902 10.6876 9.48388 10.8535 9.48267C11.0828 9.481 11.3597 9.47642 11.3593 9.46402V3.92883ZM13.7646 9.19859H12.7444V5.93939H13.1278L13.7646 9.19859Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M4.25928 4.66085H2.98085C2.88518 4.66085 2.80291 4.72861 2.78456 4.8225L1.67969 10.4771L4.25984 10.4772L4.25928 9.19859H3.23221L3.86904 5.93939H4.25928V4.66085Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M6.48438 6.65609C6.48438 6.54564 6.57392 6.45609 6.68437 6.45609H7.79459V5.34575C7.79459 5.2353 7.88413 5.14575 7.99459 5.14575H9.002C9.11245 5.14575 9.202 5.2353 9.202 5.34575V6.45609H10.3125C10.4229 6.45609 10.5125 6.54564 10.5125 6.65609V7.6635C10.5125 7.77396 10.4229 7.8635 10.3125 7.8635H9.202L9.202 8.97384C9.202 9.0843 9.11245 9.17384 9.002 9.17384H7.99459C7.88413 9.17384 7.79459 9.0843 7.79459 8.97384L7.79459 7.8635H6.68438C6.57392 7.8635 6.48438 7.77396 6.48438 7.6635V6.65609Z",
  fill: "#7FA5FF"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var New_requirement_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { New_requirement_2 as default };
